<template>
  <div class="buildingAddress" v-if="buildingAddress">
    {{ buildingAddress }}
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      buildingAddress: (state) => state.api.buildingAddress,
    }),
  },
};
</script>

<style scoped>
.buildingAddress {
  padding: 15px 20px;
  line-height: 1;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.58px;
  background-color: #b3cae2;
  z-index: 2;
  border-bottom: 2px solid var(--color-accent);
}
</style>
